export default "__VITE_ASSET__548c7722__"